import { LogIn } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useSignedOutHoldingDrafts, useUnsyncedDrafts } from '../hooks/useDraftOutbox';
import { useRepositories } from '../hooks/useRepositories';

/**
 * Shown while the page has been signed out (signed out elsewhere, or
 * suspended) but stays open because leaving would lose its unsynced drafts.
 * Sign-in opens in a new tab so this page, and the drafts in it, stay; once
 * the person is signed in again the drafts sync and the notice goes.
 */
export default function SignedOutNotice() {
  // Held only on a signed-in page, so the outbox below is there.
  return useSignedOutHoldingDrafts() ? <Notice /> : null;
}

function Notice() {
  const drafts = useUnsyncedDrafts();
  const { session } = useRepositories();
  const { pathname, search } = useLocation();

  const count = drafts.length;
  const what =
    count === 1
      ? 'your unsynced draft saves'
      : count > 1
        ? `your ${count} unsynced drafts save`
        : 'your changes save';
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-3 rounded-3xl bg-primary/10 px-5 py-3 text-sm text-foreground"
    >
      <LogIn className="size-5 shrink-0 text-primary" aria-hidden="true" />
      <p className="min-w-0 flex-1">
        You’ve been signed out. Keep this page open and sign in again in another tab so {what}.
      </p>
      <a
        href={session.signInUrl(pathname + search)}
        target="_blank"
        rel="noopener"
        className="rounded-full bg-primary px-4 py-1.5 font-semibold text-primary-foreground hover:bg-primary/90"
      >
        Sign in in a new tab
      </a>
    </div>
  );
}
